import { BookTopChart } from './BookTopChart'
import { withBookTopChart } from './withBookTopChart'

const connectedBookTopChart = withBookTopChart(BookTopChart)

export { connectedBookTopChart as BookTopChart }
